import React, { useEffect, useState } from "react";
import { Formik, Form, FieldArray, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { disabledStyle } from "../../../Common/ClickDisable";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { useDispatch } from "react-redux";
import { addAuction, updateAuction } from "../../../../redux/auction/action";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import DownloadButton from "../../../Common/FilesRelevent/DownloadButton";
import { getDateFormate } from "../../../Common/AllDateTimeReleventFormate";
import CustomeDurationLabel from "../../../Common/CustomeLabel/CustomeDurationLabel";
import ActiveHTMLDescription from "../../../Common/CustomeLabel/ReactQuill/ActiveHTMLDescription";

const bxpDatatomap = [
  { title: "Price in $", name: "price", placeholder: "Enter total cost" },

];

const PricingTerms = ({ updateindex, bxpData, setActiveTab, setModalOpen, setModal }) => {
  const [loading, setLoading] = useState(null);
  const dispatch = useDispatch();

  const initialValues = {
    price: bxpData?.price || "",
    payment_type: bxpData?.payment_type || 2,
    terms: bxpData?.terms || "",
    milestones: bxpData?.milestones || [
      {
        title: "",
        duration: "",
        amount: "",
        files: ''
      },
    ],
  };

  const validationSchema = Yup.object().shape({
    price: Yup.string().required("Price is required"),
    payment_type: Yup.string().required("Payment terms are required"),
    terms: Yup.string(),
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const updatedBxpData = {
        ...bxpData,
        price: values.price,
        payment_type: values.payment_type,
        terms: values.terms,
        milestones: values.milestones,
      };

      if (updateindex !== null) {
        dispatch(updateAuction(updatedBxpData, setLoading));
      } else {
        dispatch(addAuction(updatedBxpData, setLoading));
        localStorage.removeItem("BSA_ADD_DRAFT");
      }

      setModalOpen(false);
      setModal(false);
    } catch (error) {
      console.error("Error submitting BXP:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  return (
    <div>
      <Formik
        initialValues={initialValues}
        // validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            { }
            <div>
              {bxpDatatomap.map((prop, key) => {

                return (
                  <div className="d-flex flex-column price-flex">
                    <div className="price-duration" >
                      <h6>Item title</h6>
                      <h4>{bxpData?.title}</h4>
                    </div>
                    <div className="price-duration" >
                      <h6>Minimum bid</h6>
                      <h4>$ {bxpData?.min_bid}</h4>
                    </div>
                    {bxpData?.description && (
                      <div className="price-duration" style={{ width: '100%' }}>
                        <h6>Description</h6>
                        <ActiveHTMLDescription
                          value={bxpData?.description}
                          displyreadorless={true}
                        />
                      </div>
                    )}
                    <div className="price-duration" >
                      <h6>Item’s images</h6>
                      <>
                        {
                          Array.isArray(bxpData?.files) && bxpData?.files.filter(item => item.status != 3)
                            .map((item, index) => (
                              <div key={index} className="image-container mb-0 col-md-5 p-0 mb-3">
                                <DisplayFileProper item={item} />
                                <DownloadButton file={item} />
                              </div>
                            ))
                        }</>
                    </div>
                    <div className="price-duration" >
                      <h6>Buy & Sell with Auction (BSA) type</h6>
                      <h4>{bxpData?.auction_type == 2 ? 'Incremental' : 'Sealed'}</h4>
                    </div>
                    <div className="price-duration" >
                      <h6>Buy & Sell with Auction (BSA) date</h6>
                      <h4>{getDateFormate(bxpData?.start_date)}</h4>
                    </div>
                    <div className="price-duration" >
                      <h6>Buy & Sell with Auction (BSA) duration</h6>
                      <h4> <CustomeDurationLabel
                        duration={bxpData?.duration}
                        duration_type={bxpData?.duration_type}
                      /></h4>
                    </div>
                    <div className="price-duration" >
                      <h6>Buy & Sell with Auction (BSA) time</h6>
                      <h4>{bxpData?.start_time}</h4>
                    </div>
                    <div className="price-duration" >
                      <h6>Delivery type</h6>
                      <h4>{bxpData?.delivery_type_title ? bxpData?.delivery_type_title : "D2D (door to door)"}</h4>
                    </div>
                  </div>
                );
              })}
              <div className="button-container">
                <p
                  style={loading ? disabledStyle : {}}
                  className="prev-button w-100"
                  onClick={() => setActiveTab("WorkSamples")}
                >
                  Back
                </p>
                <button className="next-button w-100" type="submit">
                  {loading ? (
                    <LoginLoaderButton />
                  ) : updateindex !== null ? (
                    "Add and Publish"
                  ) : (
                    "Save and Publish"
                  )}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PricingTerms;
